export const USER_STATUS_MAP = {
  ALL: 'all',
  ACTIVE: 'registered',
  INACTIVE: 'inactive',
  ARCHIVED: 'archived',
  CREATED: 'created',
  PENDING: 'pending',
};

export const USER_STATUS_COLORS = {
  [USER_STATUS_MAP.ACTIVE]: 'bg-green',
  [USER_STATUS_MAP.INACTIVE]: 'bg-gray-dark',
  [USER_STATUS_MAP.ARCHIVED]: 'bg-gray-dark',
};
